export enum ContentViewVariant {
  TWO_COLUMNS = "two-columns",
  THREE_COLUMNS = "three-columns",
}
